/**
 * Half-month-aligned date range presets for the bulk mark-availability picker.
 *
 * 'first-half' = 1st-15th of the anchor's month.
 * 'second-half' = 16th-last day of the anchor's month.
 *
 * All arithmetic is done in UTC (matching build-availability-window.ts's
 * convention) so the result never drifts across a local-timezone midnight.
 */

export type HalfMonthPreset = 'first-half' | 'second-half';

export interface HalfMonthRange {
  dateFrom: string;
  dateTo: string;
}

function toIsoDate(year: number, monthIndex: number, day: number): string {
  const mm = String(monthIndex + 1).padStart(2, '0');
  const dd = String(day).padStart(2, '0');
  return `${String(year)}-${mm}-${dd}`;
}

export function buildHalfMonthRange(anchor: Date, preset: HalfMonthPreset): HalfMonthRange {
  const year = anchor.getUTCFullYear();
  const monthIndex = anchor.getUTCMonth();

  if (preset === 'first-half') {
    return {
      dateFrom: toIsoDate(year, monthIndex, 1),
      dateTo: toIsoDate(year, monthIndex, 15),
    };
  }

  const lastDay = new Date(Date.UTC(year, monthIndex + 1, 0)).getUTCDate();
  return {
    dateFrom: toIsoDate(year, monthIndex, 16),
    dateTo: toIsoDate(year, monthIndex, lastDay),
  };
}
